import {useState} from 'react'

import Style from './style'

import DefaultSlideModal from 'shared/ui/DefaultSlideModal'
import DefaultButton from 'shared/ui/DefaultButton'
import {
	RANKING_FILTER_SORT_BY,
	RANKING_FILTER_TIER,
} from 'shared/constant/ranking'
import useQueryParams from 'shared/hooks/useQueryParams'

import useGetSeriesList from 'entity/series/useGetSeriesList'
import useGetStoreList from 'entity/store/useGetStoreList'

const FilterModal = ({closeEvent}) => {
	const {getParam, setParam, updateParams} = useQueryParams()

	const levelFlag = getParam('level') || '2'
	const tierFlag = getParam('ranking') || ''
	const seriesIdx = getParam('series_idx') || ''
	const managerIdx = getParam('manager_idx') || ''

	const [tierValues, setTierValues] = useState(tierFlag ? tierFlag.split(',') : [])
	const [seriesFlag, setSeriesFlag] = useState(seriesIdx ? seriesIdx.split(',') : [])
	const [storeFlag, setStoreFlag] = useState(managerIdx ? managerIdx.split(',') : [])

	const [seriesList] = useGetSeriesList()
	const [storeList] = useGetStoreList()

	const handleLevelFlag = (value) => {
		updateParams({level: value, ranking: null})
	}

	const toggleTier = (value) => {
		setTierValues((prev) =>
			prev.includes(value) ? prev.filter((i) => i !== value) : [...prev, value]
		)
	}

	const toggleSeries = (idx) => {
		setSeriesFlag((prev) =>
			prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
		)
	}

	const toggleStore = (idx) => {
		setStoreFlag((prev) =>
			prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
		)
	}

	const handleApply = () => {
		const params = {type: '1'}

		if (levelFlag === '2' && tierValues.length > 0) {
			const filtered = tierValues.filter((v) => v !== '0')
			if (filtered.length > 0) params.ranking = filtered.join(',')
		}

		if (levelFlag === '3' && seriesFlag.length > 0) {
			params.series_idx = seriesFlag.join(',')
		} else if (levelFlag !== '3') {
			params.series_idx = null
		}

		if (levelFlag === '4' && storeFlag.length > 0) {
			params.manager_idx = storeFlag.join(',')
		} else if (levelFlag !== '4') {
			params.manager_idx = null
		}

		updateParams(params)
		closeEvent()
	}

	return (
		<DefaultSlideModal title='필터링' closeEvent={closeEvent}>
			<Style.FilterElement>
				<h2>항목</h2>
				<Style.ElementList>
					{RANKING_FILTER_SORT_BY.map((elem) => (
						<Style.Element
							onClick={() => handleLevelFlag(elem.value)}
							$active={elem.value === levelFlag}
						>
							{elem.name}
						</Style.Element>
					))}
				</Style.ElementList>
			</Style.FilterElement>

			{levelFlag === '2' && (
				<Style.FilterElement>
					<h2>티어 목록</h2>
					<Style.ElementList>
						{RANKING_FILTER_TIER.map((elem) => (
							<Style.Element
								onClick={() => toggleTier(elem.value)}
								$active={tierValues.includes(elem.value)}
							>
								{elem.name}
							</Style.Element>
						))}
					</Style.ElementList>
				</Style.FilterElement>
			)}

			{levelFlag === '3' && (
				<Style.FilterElement>
					<h2>대회 시리즈 목록</h2>
					<Style.ScrollList>
						<Style.ScrollContent>
							{seriesList?.data?.length > 0 ? (
								seriesList.data.map((elem) => (
									<Style.SelectElement
										onClick={() => toggleSeries(String(elem.idx))}
										$active={seriesFlag.includes(String(elem.idx))}
									>
										{elem.name}
									</Style.SelectElement>
								))
							) : (
								<Style.Option>
									아직 대회 시리즈가 생성되지 않았습니다.
								</Style.Option>
							)}
						</Style.ScrollContent>
					</Style.ScrollList>
				</Style.FilterElement>
			)}

			{levelFlag === '4' && (
				<Style.FilterElement>
					<h2>매장 목록</h2>
					<Style.ScrollList>
						<Style.ScrollContent>
							{storeList?.data?.length > 0 ? (
								storeList.data.map((elem) => (
									<Style.SelectElement
										onClick={() => toggleStore(String(elem.idx))}
										$active={storeFlag.includes(String(elem.idx))}
									>
										{elem.name}
									</Style.SelectElement>
								))
							) : (
								<Style.Option>
									아직 매장 정보가 생성되지 않았습니다.
								</Style.Option>
							)}
						</Style.ScrollContent>
					</Style.ScrollList>
				</Style.FilterElement>
			)}

			<DefaultButton clickEvent={handleApply}>적용</DefaultButton>
		</DefaultSlideModal>
	)
}

export default FilterModal
